/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// React Router Dom
import { useHistory } from 'react-router-dom';

// Material
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ImgMedia from '@material-ui/core/CardMedia';

// Clsx
import clsx from 'clsx';

// Icons
import Settings from '@material-ui/icons/Settings';

// Constants
import IMAGES from 'constants/images';
import PATH from 'constants/basePath';

// Actions
import { setOpen } from 'store/ducks/dialogs/actions';

// Types
import { ApplicationState } from 'store';

// Components
import { ImageUpload } from '../components/ImageUpload';

// Styles
import useStyles from './companyHeader.styles';

const CompanyHeader: React.FC = () => {
  const classes = useStyles();

  const history = useHistory();
  const dispatch = useDispatch();

  const userFirebaseData = useSelector(
    (state: ApplicationState) => state.users.firebaseData || null,
  );

  const open = useSelector((state: ApplicationState) => state.drawer.open);

  const [mouseOverLogo, setMouseOverLogo] = React.useState(false);

  const handleUploadImage = () => {
    dispatch(
      setOpen({
        open: true,
        content: <ImageUpload handleSubmit={(base64: string) => {}} />,
      }),
    );
  };

  return (
    <Box>
      <Box
        className={clsx(classes.company, {
          [classes.companyCloseDrawer]: !open,
        })}>
        <Box
          className={classes.logoContainer}
          onClick={() => handleUploadImage()}
          onMouseOver={() => setMouseOverLogo(true)}
          onMouseOut={() => setMouseOverLogo(false)}>
          <ImgMedia alt='' component='img' src='' />
          <ImgMedia
            alt=''
            component='img'
            src={IMAGES.ICONS.WHITE_PENCIL}
            className={clsx(classes.logoUpdate, {
              [classes.hiddenImage]: !mouseOverLogo,
            })}
          />
        </Box>
        <Typography component='span' className={classes.companyLabel}>
          {userFirebaseData && userFirebaseData.displayName}
        </Typography>
        <div />
      </Box>
      <Box
        className={clsx(classes.settings, {
          [classes.settingsDawerClose]: !open,
        })}>
        <IconButton
          onClick={() => {
            // eslint-disable-next-line
            !open
              ? history.push(
                  `${PATH.COMPANIES.BASE_URL}/editar/${userFirebaseData.uid}`,
                )
              : {};
          }}>
          <Settings
            className={clsx(classes.settingsIcon, {
              [classes.marginIcon]: !open,
            })}
          />
        </IconButton>
        <Button
          color='inherit'
          onClick={() =>
            history.push(
              `${PATH.COMPANIES.BASE_URL}/editar/${userFirebaseData.uid}`,
            )
          }>
          <Typography component='span' className={classes.settingsText}>
            Gerenciar Empresa
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default CompanyHeader;
export { CompanyHeader };
